<template>
  <div>
    <v-toolbar flat> 
      <v-toolbar-title>Imputación de ventas</v-toolbar-title>
    </v-toolbar>
    <v-row>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.debitos_totales && edited.debitos_totales.length > 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ edited.debitos_totales.reduce((acc, item) => acc + parseFloat(item.importe), 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-1-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total de cargas registradas.</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(item, index) in edited.debitos_totales">
            <v-list-item two-line :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ productoNombre(item.producto_id) }}</v-list-item-subtitle>
                <v-list-item-title>$ {{ parseFloat(item.importe) | formatToTwoDecimals }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.debitos_precio_pleno && edited.debitos_precio_pleno.length > 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ edited.debitos_precio_pleno.reduce((acc, item) => acc + parseFloat(item.importe), 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-2-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total de cargas pagadas a precio planta</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(item, index) in edited.debitos_precio_pleno">
            <v-list-item two-line :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ productoNombre(item.producto_id) }}</v-list-item-subtitle>
                <v-list-item-title>$ {{ parseFloat(item.importe) | formatToTwoDecimals }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.debitos_precio_subsidio && edited.debitos_precio_subsidio.length > 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ edited.debitos_precio_subsidio.reduce((acc, item) => acc + parseFloat(item.importe), 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-3-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total de subsidio imputado a las cargas registradas</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(item, index) in edited.debitos_precio_subsidio">
            <v-list-item two-line :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ productoNombre(item.producto_id) }}</v-list-item-subtitle>
                <v-list-item-title>$ {{ parseFloat(item.importe) | formatToTwoDecimals }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card>
      </v-col>
    </v-row>
    <v-toolbar flat> 
      <v-toolbar-title>Deudas de usuarios</v-toolbar-title>
    </v-toolbar>
    <v-row>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.deuda_usuario_total != null && edited.deuda_usuario_total >= 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ parseFloat(edited.deuda_usuario_total) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-4-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total deuda de usuario por kg cancelado con bonos</v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-toolbar flat> 
      <v-toolbar-title>Imputación de pagos</v-toolbar-title>
    </v-toolbar>
    <v-row>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.creditos_precio_usuario && edited.creditos_precio_usuario.length > 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ edited.creditos_precio_usuario.reduce((acc, item) => acc + parseFloat(item.importe), 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-5-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total de pagos aplicados a deuda de usuario</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(item, index) in edited.creditos_precio_usuario">
            <v-list-item two-line :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ formaPagoNombre(item.forma_pago_id) }}</v-list-item-subtitle>
                <v-list-item-title>$ {{ parseFloat(item.importe) | formatToTwoDecimals }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card
          v-if="edited.creditos_precio_pleno && edited.creditos_precio_pleno.length > 0"
          class="mx-auto"
          max-width="400"
        >
          <v-card-title class="text-h6">
            $ {{ edited.creditos_precio_pleno.reduce((acc, item) => acc + parseFloat(item.importe), 0) | formatToTwoDecimals }}
            <v-spacer />
            <v-icon>mdi-numeric-6-box</v-icon>
          </v-card-title>

          <v-card-subtitle>Total de pagos aplicados a precio planta</v-card-subtitle>
          <v-divider></v-divider>
          <template v-for="(item, index) in edited.creditos_precio_pleno">
            <v-list-item two-line :key="index">
              <v-list-item-content>
                <v-list-item-subtitle>{{ formaPagoNombre(item.forma_pago_id) }}</v-list-item-subtitle>
                <v-list-item-title>$ {{ parseFloat(item.importe) | formatToTwoDecimals }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import ProductosMixin from '@/mixins/Productos'
import FormasDePagosMixin from '@/mixins/FormasDePagos'
export default {
  name: 'ReportesVentasComponent',
  mixins: [ProductosMixin, FormasDePagosMixin],
  data () {
    return {
      //
    }
  },
  beforeDestroy () {
    this.onClearEdited()
  },
  computed: {
    ...mapGetters('ReportesVentas', ['edited', 'loading', 'filters']),
  },
  methods: {
    ...mapActions('ReportesVentas', ['onClearEdited'])
  }
}
</script>
